import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebaseConfig";
import { setDoc, doc, getDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  console.log("Current user:", auth.currentUser);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await signInWithEmailAndPassword(auth, email, password);
      const userDocRef = doc(db, "users", res.user.uid);
      const userSnap = await getDoc(userDocRef);

      if (!userSnap.exists()) {
        await setDoc(userDocRef, {
          email,
          firstName: "First",
          lastName: "Last",
        });
      }
    } catch (err) {
      setError("Invalid email or password");
    }
  };

  return (
    <div className="min-h-screen bg-[#f4f6fb] flex flex-col items-center justify-center px-4">
      <img
        src="https://mesyeuxtesyeux.com/images/home/Logo/mesyeuxtesyeuxLOGOTRANSPARENT2.png"
        alt="Mes Yeux Tes Yeux"
        className="w-32 mb-6"
      />

      <form
        onSubmit={handleLogin}
        className="w-full max-w-sm bg-white shadow-md rounded-xl px-6 py-8 space-y-5"
      >
        <h2 className="text-xl font-bold text-gray-800 text-center">Login</h2>

        <input
          type="email"
          placeholder="Email"
          className="w-full p-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <input
          type="password"
          placeholder="Password"
          className="w-full p-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        {error && <p className="text-red-500 text-sm">{error}</p>}

        <div className="text-right text-sm text-blue-600 hover:underline cursor-pointer">
          Forgot password?
        </div>

        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition"
        >
          Continue
        </button>
      </form>
    </div>
  );
};

export default LoginPage;
